import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Button from '../Button'

const SignedOutBlock = ({
  openLoginModal
}) => (
  <div className="flex flex-wrap border-b mt-8 pb-8">
    <div className="flex-grow">
      <h5 className="uppercase text-grey tracking-wide-2xl">
        <FormattedMessage id="booking.amountForm.login.subHeader" defaultMessage="Login to your SKI365 account" />
      </h5>
      <h2 className="mt-5">
        <div>
          <FormattedMessage id="booking.amountForm.login.headerLn1" defaultMessage="Have an account?" />
        </div>
        <FormattedMessage id="booking.amountForm.login.headerLn2" defaultMessage="Login here" />
      </h2>
    </div>

    <div className="flex items-end">
      <Button onClick={openLoginModal} className="bg-grass">
        <FormattedMessage id="booking.amountForm.login.button" defaultMessage="Login" />
      </Button>
    </div>
  </div>  
)

SignedOutBlock.propTypes = {
  openLoginModal: PropTypes.func.isRequired
}

export default SignedOutBlock